import { numberWithCurrency } from '@hivebrite/utils';
import { __, s__ } from '@design-system/i18n';
import { isLifetimeRecurringItem } from './recurringItem';
import { CURRENCY_DISPLAY, periodicityTranslations } from '../constants';
export const generateRecurringPaymentText = (items, locale, isSecondNotice = false) => {
    if (items.length === 0) {
        return '';
    }
    const recurringItems = items.filter(isLifetimeRecurringItem);
    if (recurringItems.length === 0) {
        return '';
    }
    const groupedRecurring = {};
    for (const item of recurringItems) {
        const { periodicity } = item;
        if (!groupedRecurring[periodicity]) {
            groupedRecurring[periodicity] = [];
        }
        groupedRecurring[periodicity].push(item);
    }
    const recurringPayments = [];
    for (const periodicity of Object.keys(groupedRecurring)) {
        const groupItems = groupedRecurring[periodicity];
        const currency = groupItems[0].currency;
        const groupTotal = groupItems.reduce((result, { original_total: originalTotal = 0, quantity = 1 }) => result + quantity * originalTotal, 0);
        const recurringPayment = numberWithCurrency({
            currency,
            options: {
                currencyDisplay: CURRENCY_DISPLAY,
                locale,
            },
            value: groupTotal,
        });
        recurringPayments.push(s__('OrderSummary|%{paymentAmount} every %{period}').i__({
            paymentAmount: recurringPayment,
            period: periodicityTranslations[periodicity],
        }));
    }
    let paymentText = isSecondNotice
        ? s__('OrderSummary|And %{recurringPaymentsString}').i__({
            recurringPaymentsString: recurringPayments.join(` ${__('and')} `),
        })
        : s__('OrderSummary|Then %{recurringPaymentsString}').i__({
            recurringPaymentsString: recurringPayments.join(` ${__('and')} `),
        });
    const freeTrials = recurringItems.reduce((acc, item) => acc + (item.has_free_trial ? 1 : 0), 0);
    if (freeTrials === 1) {
        paymentText += ' ' + s__('OrderSummary|after the end of your free trial.');
    }
    else if (freeTrials > 1) {
        paymentText += ' ' + s__('OrderSummary|after the end of your free trials.');
    }
    else {
        paymentText += '.';
    }
    return paymentText;
};
//# sourceMappingURL=generateRecurringPaymentText.js.map